import {ErrorDtoFactory, FlyerWithoutPageImagesDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as FlyerWithoutPageImagesActions} from "../actions/flyerWithoutPageImagesActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";
import {FlyersState} from "../reducers/flyersReducer";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {Action as FlyersActions} from "../actions/flyersActions";
import {Action as ToggleActionForEditorActions} from "../actions/toggleActionForEditorActions";
import {dispatchEventDataType, EVENT_DATA_TYPE_OPEN_PAGES_FLYER} from "../../globals/EventDispatcher";

export const createFlyerWithoutPageImages = (
    data: FlyerWithoutPageImagesDto,
    flyersState?: FlyersState
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlyerWithoutPageImagesActions | FlyerDetailsActions | FlyersActions | ToggleActionForEditorActions>
    ) => {
        dispatch({
            type: ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_START,
        });

        try {
            let result: any = await createFlyerWithoutPageImagesRequest(
                data,
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data.flyer;
            dispatch({
                type: ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_SUCCESS,
                payload: flyer.flyRecId,
            });
            // dispatch({
            //     type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
            //     payload: flyer,
            // });
            if (flyersState) {
                const flyersStatePayload: FlyersState = {
                    ...flyersState,
                    flyers: [flyer, ...flyersState.flyers],
                };
                // dispatch({
                //     type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                //     payload: flyer,
                // });
                dispatchEventDataType<string | undefined>(
                    EVENT_DATA_TYPE_OPEN_PAGES_FLYER,
                    {
                        isOpen: true,
                        flyerCaption: flyer.flyCaption
                    }
                );
                dispatch({
                    type: ActionType.CHANGE_FLYERS_STATE,
                    payload: flyersStatePayload,
                });
            }
            localStorage.removeItem(`userEnterForFirstTime${userDto.userId}`);
            dispatch({
                type: ActionType.EDITOR_TOGGLE_FLYER_DETAILS_POPUP,
                payload: false
            })
            dispatch({
                type: ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_COMPLETED
            });

            // dispatch({
            //     type: ActionType.EDITOR_TOGGLE_FLYER_DETAILS_POPUP,
            //     payload: false,
            // })
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

const createFlyerWithoutPageImagesRequest = (
    data: FlyerWithoutPageImagesDto,
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`NoPages`, data.numberOfPages);
            formData.append(`WidthPx`, data.pageWidth);
            formData.append(`HeightPx`, data.pageHeight);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },

            };
            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/CreateFlyerWithoutPageImages`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};





